export const EK_USE_IMPORT_FROM_CLIPBOARD = 'EK_USE_IMPORT_FROM_CLIPBOARD';
export const EK_BOKFORDER_UTANORDNING_ACTIVE =
  'EK_BOKFORDER_UTANORDNING_ACTIVE';
export const EK_BOKFORDER_ATTESTANT_EDIT_KONTERING =
  'EK_BOKFORDER_ATTESTANT_EDIT_KONTERING';
export const EK_BOKFORDER_UTANORDNING_DUBBEL_ATTEST =
  'EK_BOKFORDER_UTANORDNING_DUBBEL_ATTEST';
